import { alpha, createTheme } from "@mui/material/styles";
import { darkPalette, lightPalette } from "./palette";

const DRAWER_WIDTH = 260;
const DRAWER_WIDTH_COLLAPSED = 72;

function createCrmTheme(mode = "light") {
  const palette = mode === "dark" ? darkPalette : lightPalette;

  return createTheme({
    palette,
    typography: {
      fontFamily:
        '"Plus Jakarta Sans", "Noto Sans Devanagari", "Noto Sans Gujarati", "Roboto", "Helvetica", "Arial", sans-serif',
      h1: { fontWeight: 800, letterSpacing: "-0.025em" },
      h2: { fontWeight: 700, letterSpacing: "-0.02em" },
      h3: { fontWeight: 700, letterSpacing: "-0.015em" },
      h4: { fontWeight: 700, letterSpacing: "-0.01em" },
      h5: { fontWeight: 600 },
      h6: { fontWeight: 600 },
      subtitle1: { fontWeight: 500 },
      subtitle2: { fontWeight: 600, letterSpacing: "0.01em" },
      button: { textTransform: "none", fontWeight: 600 },
    },
    shape: { borderRadius: 12 },
    components: {
      MuiButton: {
        defaultProps: { disableElevation: true },
        styleOverrides: {
          root: {
            borderRadius: 10,
            padding: "8px 18px",
            transition: "all 0.2s cubic-bezier(0.4, 0, 0.2, 1)",
          },
          containedPrimary: {
            background: palette.gradient.primary,
            boxShadow:
              mode === "dark"
                ? "0 4px 14px rgba(239, 68, 68, 0.35)"
                : "0 4px 14px rgba(181, 40, 28, 0.28)",
            "&:hover": {
              boxShadow:
                mode === "dark"
                  ? "0 6px 20px rgba(239, 68, 68, 0.45)"
                  : "0 6px 20px rgba(181, 40, 28, 0.38)",
              transform: "translateY(-1px)",
            },
          },
          containedSecondary: {
            background: palette.gradient.navy,
            boxShadow: "0 4px 14px rgba(11, 43, 108, 0.25)",
            "&:hover": {
              boxShadow: "0 6px 20px rgba(11, 43, 108, 0.35)",
              transform: "translateY(-1px)",
            },
          },
        },
      },
      MuiCard: {
        styleOverrides: {
          root: {
            borderRadius: 16,
            border: `1px solid ${palette.divider}`,
            boxShadow:
              mode === "dark"
                ? "0 8px 24px rgba(0, 0, 0, 0.4)"
                : "0 8px 24px rgba(15, 23, 42, 0.05)",
            backgroundImage: "none",
          },
        },
      },
      MuiPaper: {
        styleOverrides: {
          root: { backgroundImage: "none" },
        },
      },
      MuiChip: {
        styleOverrides: {
          root: { fontWeight: 600, borderRadius: 8 },
        },
      },
      MuiTextField: {
        defaultProps: { variant: "outlined" },
      },
      MuiOutlinedInput: {
        styleOverrides: {
          root: { borderRadius: 10 },
        },
      },
      MuiDialog: {
        styleOverrides: {
          paper: { borderRadius: 12 },
        },
      },
    },
  });
}

/** @deprecated use createCrmTheme via AppThemeProvider */
const crmTheme = createCrmTheme("light");

export { DRAWER_WIDTH, DRAWER_WIDTH_COLLAPSED, createCrmTheme, crmTheme };
